import { Pixall } from '../analytics/index.js';
import { getInventoryOwnerById } from '../utilities/index.js';

/**
 * @summary Sends Google and Pixall event for chatbot AI CTA click on vdp
 */
export function chatbotCTAClick(metadata, option) {
  if (option === void 0) {
    option = {};
  }
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId,
    linkText
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  Pixall.sendClickEvent({
    eventSource: 'userAccount',
    label: `chatbot::initiation::${linkText}`,
    feature: 'chat',
    inventory
  }, dataLayer, option);
  return {};
}

/**
 * @summary Google impression for chatbot AI on vdp
 */
export function chatbotImpression(metadata, option) {
  const {
    data = {},
    dataLayer = {}
  } = metadata;
  const {
    siteArea
  } = data;
  const featureMapping = {
    atc: 'my-at',
    kbb: 'my-kbb'
  };
  Pixall.sendImpression(metadata, {
    eventSource: 'userAccount',
    eventType: 'loaded',
    label: `chatbot::text::${siteArea}`,
    feature: featureMapping[dataLayer.brand?.toLowerCase()] || 'my-kbb'
  }, option);
  return {};
}
export default {
  chatbotCTAClick,
  chatbotImpression
};